import $ from 'cash-dom';

class VendorsReadMoreHandler {
	constructor($vendorsContainer) {
		this._$vendorsContainer = $vendorsContainer || $('.vendors-list');
	}

	init() {
		this._showNeededReadMore();

		$(document).on('filters-change', () => {
			this._showNeededReadMore();
		});
	}

	_showNeededReadMore() {
		const howManyReadMore = this._$vendorsContainer.data('how-many-read-more-to-open');

		if (!howManyReadMore) {
			return;
		}

		this._$vendorsContainer.find('.ppc-single-vendor').each((index, vendor) => {
			const $vendor = $(vendor);
			const position = index + 1;

			if (howManyReadMore === 'all' || position <= howManyReadMore) {
				$vendor.find('.read-more-holder').addClass('open');
				$vendor.find('.read-more-holder .read-more-container').addClass('open');
				$vendor.find('.read-more-content').addClass('open');
			} else {
				$vendor.find('.read-more-holder').removeClass('open');
				$vendor.find('.read-more-holder .read-more-container').removeClass('open');
				$vendor.find('.read-more-content').removeClass('open');
			}
		});
	}
}

export default VendorsReadMoreHandler;